<section class="app flex-container" fxLayout="column" fxLayoutAlign="start stretch">

  <div>
    <app-chart [chartTitle]="chartTitle"></app-chart>
  </div>


</section>
